import { useTheme } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { DocumentCreateOrUploadForm } from 'documents/DocumentCreateOrUploadForm';
import { DocumentDetailDialog } from 'documents/DocumentDetailDialog';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { IPurchase, PurchaseType } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { RecordContext } from 'shared/records/RecordContext';

interface IProps {
	item: IPurchase;
	reload: VoidFunction;
	style?: React.CSSProperties;
}

export const PurchaseDetailDocumentContent = ({ item, reload, style }: IProps) => {
	const strings = useLocalization();
	const { purchaseTypeRecord } = useContext(RecordContext);
	const { open, confirm, cancel } = useDialogsContext(reload);
	const theme = useTheme();

	const onNew = () => {
		open(
			<DocumentCreateOrUploadForm
				title='Aankoopfactuur'
				context='Purchase'
				contextId={item.id}
				confirm={confirm}
				cancel={cancel}
			/>
		);
	};

	const onViewDetail = (documentId: string) => {
		open(
			<DocumentDetailDialog
				open
				close={confirm}
				id={documentId}
			/>
		);
	};

	return (
		<div
			className='df-col gap-6'
			style={style}>
			<div
				className='df-row-ac'
				style={{ fontSize: 12, color: theme.palette.text.secondary }}>
				<span>{strings.documents}</span>
				<div className='fg1'></div>
				<DescriptionOutlinedIcon style={{ fontSize: 16 }} />
			</div>
			<TextLinkButton
				startIcon={<DescriptionOutlinedIcon />}
				color={item.hasDocument === false ? 'secondary' : undefined}
				onClick={() => (item.hasDocument ? onViewDetail(item.documentId!) : onNew())}>
				{item.hasDocument === false && <em>{strings.uploadWhat(purchaseTypeRecord[item.type as PurchaseType])}</em>}
				{item.hasDocument === true && strings.viewEditWhat(purchaseTypeRecord[item.type as PurchaseType])}
			</TextLinkButton>
		</div>
	);
};
